module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"result":"Ergebnis","unit":"Einheit","quantity":"Menge","productId":"Artikelnr.","product":"Artikel","search":"Suche","receiptId":"Belegnr.","stock":"Soll GE"},"en":{"result":"Result","unit":"Unit","quantity":"Quantity","productId":"Product id","product":"Product","search":"Search","receiptId":"Receipt id","stock":"Stock"}}')
  delete Component.options._Ctor
}
